export default __webpack_public_path__ + "static/screenshot-content-349eb57d3722750dc8e571576c9b4df3.png";